module.exports = __webpack_public_path__ + "static/media/achievement_01.3a69c5a1.png";